import http from '@/plugins/axios/axios';

export default class PlanoIKAcessoService {

    constructor() {
        this.baseUrl = process.env.VUE_APP_BASE_URL_ADMIN_IKACESSO;      
    }

    salvar(requisicao) {
        return http.request({
            method: 'post',
            withCredentials: true,
            url: this.baseUrl + '/api/plano/v1',
            data: requisicao
        });
    }

    alterar(requisicao) {
        return http.request({
            method: 'put',
            withCredentials: true,
            url: this.baseUrl + '/api/plano/v1',
            data: requisicao
        });
    }

    listarTodos() {
        return http.request({
            method: 'get',
            withCredentials: true,
            url: this.baseUrl + '/api/plano/v1'
        });
    }

    buscarAtual() {
        return http.request({
            method: 'get',
            withCredentials: true,
            url: this.baseUrl + '/api/plano/v1/buscar-atual'
        });
    }

    publicar(id) {
        return http.request({
            method: 'put',
            withCredentials: true,
            url: this.baseUrl + '/api/plano/v1/publicar/' + id
        });
    }

    excluir(id) {
        return http.request({
            method: 'delete',
            withCredentials: true,
            url: this.baseUrl + '/api/plano/v1' + id
        });
    }
}
